import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../lib/pocketbaseClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      if (pb.authStore.isValid && pb.authStore.model) {
        try {
          const fullUser = await pb.collection('users').getOne(pb.authStore.model.id, {
            $autoCancel: false,
          });
          setUser(fullUser);
        } catch {
          pb.authStore.clear();
          localStorage.removeItem('pb_auth');
          setUser(null);
        }
      }
      setLoading(false);
    };
    loadUser();
    const unsubscribe = pb.authStore.onChange(() => loadUser());
    return () => unsubscribe();
  }, []);

  const login = async (email, password) => {
    try {
      const authData = await pb.collection('users').authWithPassword(email, password);
      const fullUser = await pb.collection('users').getOne(authData.record.id, {
        $autoCancel: false,
      });
      pb.authStore.save(authData.token, fullUser);
      localStorage.setItem('pb_auth', JSON.stringify({ token: authData.token, model: fullUser }));
      setUser(fullUser);
      return { success: true, user: fullUser };
    } catch (error) {
      return { success: false, error: error.message };
    }
  };

  const logout = () => {
    pb.authStore.clear();
    localStorage.removeItem('pb_auth');
    setUser(null);
  };

  const value = { user, loading, login, logout, isAuthenticated: !!user };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};